import {CommentBox} from '@github-ui/comment-box/CommentBox'
import {type MarkdownComposerRef, useMarkdownBody} from '@github-ui/commenting/useMarkdownBody'
import {useCurrentRepository} from '@github-ui/current-repository'
import {encodePart} from '@github-ui/paths'
import {verifiedFetch} from '@github-ui/verified-fetch'
import {useCSRFToken} from '@github-ui/use-csrf-token'

import {forwardRef, useCallback, useRef} from 'react'
import type {CommitComment} from '../../types/commit-types'

const NewCommitComment = forwardRef<
  MarkdownComposerRef,
  {commitOid: string; addComment: (comment: CommitComment) => void}
>(({commitOid, addComment}, ref) => {
  const repo = useCurrentRepository()
  const saveUrl = `/${encodePart(repo.ownerLogin)}/${encodePart(repo.name)}/commit_comment/create`
  const savingToken = useCSRFToken(saveUrl, 'post')

  const commentBoxRef = useRef(null)

  const onChange = useCallback(() => {}, [])
  const onCancel = useCallback(() => {}, [])

  const {markdownBody, resetMarkdownBody, markdownValidationResult, handleMarkdownBodyChanged} = useMarkdownBody({
    commentBoxRef,
    markdownComposerRef: ref,
    onChange,
    onCancel,
    referenceId: commitOid,
  })

  const onSave = async () => {
    const formData = new FormData()

    // eslint-disable-next-line github/authenticity-token
    formData.append('authenticity_token', savingToken!)
    formData.append('commit_id', commitOid)
    formData.append('comment[body]', markdownBody)
    const resonse = await verifiedFetch(saveUrl, {
      method: 'POST',
      body: formData,
    })

    if (resonse.ok) {
      const comment = (await resonse.json()).comment as CommitComment
      addComment(comment)
      resetMarkdownBody()
    } else {
      // TODO - handle error
    }
  }

  return (
    <CommentBox
      ref={commentBoxRef}
      validationResult={markdownValidationResult}
      onChange={handleMarkdownBodyChanged}
      onCancel={resetMarkdownBody}
      onSave={onSave}
      value={markdownBody}
    />
  )
})

NewCommitComment.displayName = 'NewCommitComment'
export {NewCommitComment}
